<ffd-tooth-highlight
  class="w-[288px] shrink-0 rounded-r-4xl"
  [toothHistory]="vm.toothHistory ?? []"
  [perioHistory]="vm.perioExams"
  [date]="vm.date"
  [patientId]="vm.patientId"
  [defaultView]="vm.view"
  (leftClick)="onLeftClick()"
  (rightClick)="onRightClick()"
  (historyClick)="toothNotes.scrollToVisit($event)"
  (toggleClick)="onToggleClick($event)"
></ffd-tooth-highlight>

<div class="flex flex-1 flex-col gap-4 py-4" #detailsContainer>
  <div class="flex items-center justify-between px-2">
    <div class="typo-h2 inline-flex text-text-primary">{{ 'charting_details_title' | translate }}</div>
    <button (click)="onCloseClick()">
      <svg-icon class="text-text-primary" key="px-24-x" size="md"></svg-icon>
    </button>
  </div>
  <div class="relative flex flex-1 overflow-hidden" #container>
    <div class="flex-shrink-0 overflow-auto rounded-[32px] bg-background-white pt-6" [style.width.%]="leftPaneWidthSignal()">
      <ffd-tooth-details-notes
        #toothNotes
        [toothPosition]="vm.toothPosition"
        [visits]="vm.visits"
        [visitsLoading]="vm.visitsLoading"
        [siteId]="vm.siteId"
        [patientId]="vm.patientId"
        [isTimeZoneDifferentFromLocal]="vm.isTimeZoneDifferentFromLocal"
        (hideConditionClick)="onHideConditionClick($event)"
        (deleteProgressNoteClick)="onDeleteProgressNoteClick($event)"
        [view]="vm.view"
        [isNotesEmpty]="vm.visits.length === 0"
        [isCollapsed]="isLeftPaneCollapsed()"
        [opacity]="leftPaneOpacitySignal()"
        (visitDateClick)="onVisitDateClick($event)"
        (collapseClick)="onNotesCollapseClick()"
      />
    </div>

    <div
      class="z-10 flex flex-shrink-0 cursor-ew-resize px-3"
      #handle
      cdkDrag
      cdkDragBoundary=".relative"
      cdkDragLockAxis="x"
      (cdkDragMoved)="onDragMoved($event)"
    >
      <div class="flex h-[20px] w-[10px] gap-[3px] self-center">
        <div class="w-[1px] rounded-full bg-[#c4c4c4]"></div>
        <div class="w-[1px] rounded-full bg-[#c4c4c4]"></div>
        <div class="w-[1px] rounded-full bg-[#c4c4c4]"></div>
      </div>
    </div>

    <div class="flex-grow overflow-auto rounded-[32px] bg-background-white pt-6" [style.width.%]="rightPaneWidthSignal()">
      <ffd-tooth-details-imaging
        [siteId]="vm.siteId"
        [patientId]="vm.patientId"
        [images]="vm.images"
        [hasImagingSoftware]="vm.hasImagingSoftware"
        [isCollapsed]="isRightPaneCollapsed()"
        [opacity]="rightPaneOpacitySignal()"
        (collapseClick)="onImagingCollapseClick()"
      />
    </div>
  </div>
</div>
